const RECENT_KEY = "recentTemplates";

export function getRecentTemplates() {
  const stored = localStorage.getItem(RECENT_KEY);
  return stored ? JSON.parse(stored) : [];
}

export function addRecentTemplate(template) {
  const recent = getRecentTemplates();

  // Remove if already exists
  const filtered = recent.filter(t => t.slug !== template.slug);

  // Add to beginning
  const updated = [template, ...filtered].slice(0, 3); // max 3

  localStorage.setItem(RECENT_KEY, JSON.stringify(updated));
}
